export default __webpack_public_path__ + "img/detail.52e37541.png";